import { Dialog } from 'vant'
import InfiniteLoading from 'vue-infinite-loading'
import {
    Error
} from '@/components/customPromotion'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import searchInput from '@/components/searchInput/searchInput'
import { GoodsList, ServerList } from '@/components/aggregation'
// import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import {
    getAggregationSearchList,
    getAggregationInitSearchList
} from '@/models/aggregationSearch'
import { wxShare } from '@/utils/wxsdk'

export default {
    name: viewName.aggregationSearch,
    components: {
        searchInput,
        GoodsList,
        ServerList,
        InfiniteLoading,
        Error
    },
    data () {
        return {
            tabs_sort: [],
            isSearch: false,
            text: '',
            pageStatus: true,
            isload: false,
            isload2: false,
            page: 0, // 商品页
            page2: 0, // 服务页
            carDetail: '',
            vehicle_id: '',
            goods: [],
            server: [],
            currentTab: 0,
            topic_id: '',
            sstore_id: '',
            keyword: '',
            flag: false, // 如果翻到最后页count和goods长度相等，翻下一页没有数据，flag为true，不能继续翻页
            flag2: false,
            sms_id: '',
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        })
    },
    inject: ['showLoading', 'hideLoading'],
    async created () {
        this.$emit('setHeader', {
            title: '搜索',
            showHeader: true,
            showLeft: true,
        })
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        this.vehicle_id = this.$route.query.vehicle_id || this.$store.state.aggregation.vehicle_id || ''
        this.topic_id = this.$route.query.topic_id || this.$store.state.aggregation.topic_id || localStorage.getItem('TOPICID') || ''
        this.sstore_id = this.$route.query.sstore_id || this.$store.state.aggregation.sstore_id || localStorage.getItem('SSTOREID') || ''
        this.sms_id = this.$route.query.sms_id || this.$store.state.aggregation.sms_id || localStorage.getItem('SMSID') || ''
        if (!this.topic_id || !this.sstore_id) {
            this.pageStatus = false
            Dialog.alert({
                message: '页面缺少参数'
            })
            return
        }
        this.isSearch = true
        this.showLoading()
        const res = await getAggregationInitSearchList({
            topic_id: this.topic_id,
            sstore_id: this.sstore_id,
            vehicle_id: this.vehicle_id,
            pagesize: 20
        })
        this.tabs_sort = res.tabs_sort
        this.carDetail = this.$route.query.carDetail || res.vehicle_name
        this.currentTab = this.$store.state.aggregation.currentTab || this.$route.query.currentTab || this.tabs_sort[0] || 0
        this.configWxShare(res.share)
        this.isSearch = false
        this.hideLoading()
    },
    mounted () {
        window.scrollTo(0, 0)
    },
    activated () {

    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        goAggregation () {
            this.$router.push({
                path: '/aggregation',
                query: {
                    topic_id: this.topic_id,
                    sstore_id: this.sstore_id,
                    sms_id: this.sms_id,
                    vehicle_id: this.vehicle_id,
                    carDetail: this.carDetail
                }
            })
        },
        async getSearchList () {
            this.isSearch = true
            this.showLoading()
            let count = 0
            if (Number(this.currentTab) === 1) {
                this.isload = true
                this.page++
            } else {
                this.isload2 = true
                this.page2++
            }
            const res = await getAggregationSearchList({
                topic_id: this.topic_id,
                sstore_id: this.sstore_id,
                topic_type: this.currentTab,
                keyword: this.keyword,
                vehicle_id: this.vehicle_id,
                page: Number(this.currentTab) === 1 ? this.page : this.page2,
                pagesize: 20
            })
            this.isSearch = false
            this.hideLoading()
            if (Number(this.currentTab) === 1) {
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                this.isload = false
                if (res.list.length < 20) {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
                this.goods = this.goods.concat(res.list)
            } else {
                this.isload2 = false
                this.$refs.infiniteLoading2 && this.$refs.infiniteLoading2.stateChanger.reset()
                if (res.list.length < 20) {
                    this.$refs.infiniteLoading2 && this.$refs.infiniteLoading2.stateChanger.complete()
                } else {
                    this.$refs.infiniteLoading2 && this.$refs.infiniteLoading2.stateChanger.loaded()
                }
                this.server = this.server.concat(res.list)
            }
            count = Number(this.currentTab) === 1 ? this.page * 20 : this.page2 * 20
            Number(this.currentTab) === 1 ? this.count = count : this.count2 = count
        },
        goToServer (item) {
            this.$router.push({
                path: '/serviceDetail',
                query: {
                    sstore_id: this.sstore_id,
                    service_id: item.server_id,
                    sms_id: this.sms_id
                    // showBuy: true
                }
            })
        },
        goToGoods (item) {
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    sstore_id: this.sstore_id,
                    goods_type: item.goods_type,
                    spu_id: item.spu_id,
                    spec_id: item.spec_id,
                    sms_id: this.sms_id
                }
            })
        },
        changeTab (value) {
            if (this.isSearch || this.currentTab === value) {
                return
            }
            window.scrollTo(0, 0)
            this.$store.commit('SET_CURRENT_TAB', value)
            this.currentTab = value
            this.page = 0
            this.page2 = 0
            this.flag = false
            this.flag2 = false
            this.goods = []
            this.server = []
            this.getSearchList()
        },
        goCarSelect () {
            this.$router.push({
                path: '/carBrandSelect',
                query: {
                    fromPath:'/aggregationSearch'
                }
            })
        },
        search () {
            if (this.isSearch) {
                return
            }
            this.keyword = this.text
            this.currentTab === 1 ? this.page = 0 : this.page2 = 0
            this.currentTab === 1 ? this.flag = false : this.flag2 = false
            this.currentTab === 1 ? this.goods = [] : this.server = []
            // this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
            // this.$refs.infiniteLoading2 && this.$refs.infiniteLoading2.stateChanger.reset()
            this.getSearchList()
        },
        clearCarDetail (e) {
            e.stopPropagation()
            if (this.isSearch) {
                return
            }
            this.carDetail = ''
            this.flag = false
            this.vehicle_id = ''
            this.page = 0
            this.goods = []
            this.getSearchList()
            this.clientHeight++
        },
        configWxShare (item) {
            if (this.isWeixin) {
                const params = {
                    title: item.title,
                    desc: item.share_content,
                    imgUrl: item.imgUrl,
                    link: location.href
                }
                wxShare(params)
            }
        }
    },
    destroyed () {

    },
}
